import { useEffect, useLayoutEffect } from 'react';

export const useLayoutEffectWithoutSsrWarning = SSR_MODE ? useEffect : useLayoutEffect;
